export { default } from "../assertThisInitialized/_index.mjs"